module.exports = __webpack_public_path__ + "img/11_63.e9dd4a06.png";